import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export async function submitForm(payload) {
  const { data } = await api.post("/submissions", payload);
  return data;
}

export async function submitBusinessApplication(payload) {
  const { data } = await api.post("/business-applications", payload);
  return data;
}

export async function listBlogPosts(q = "") {
  const { data } = await api.get("/blog/posts", { params: q ? { q } : {} });
  return data;
}

export async function getBlogPost(slug) {
  const { data } = await api.get(`/blog/posts/${slug}`);
  return data;
}

export async function authExchange(session_id) {
  const { data } = await api.post("/auth/session", { session_id });
  return data;
}

export async function authMe() {
  const { data } = await api.get("/auth/me");
  return data;
}

export async function authLogout() {
  const { data } = await api.post("/auth/logout");
  return data;
}

// Admin
export async function adminListSubmissions() {
  const { data } = await api.get("/admin/submissions");
  return data;
}

export async function adminListBusinessApplications() {
  const { data } = await api.get("/admin/business-applications");
  return data;
}

export async function adminListPosts() {
  const { data } = await api.get("/admin/blog/posts");
  return data;
}

export async function adminCreatePost(payload) {
  const { data } = await api.post("/admin/blog/posts", payload);
  return data;
}

export async function adminUpdatePost(post_id, payload) {
  const { data } = await api.put(`/admin/blog/posts/${post_id}`, payload);
  return data;
}

export async function adminDeletePost(post_id) {
  const { data } = await api.delete(`/admin/blog/posts/${post_id}`);
  return data;
}
